import { AfterViewInit, Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Company, typeInterface } from 'src/app/shared/Interfaces/company';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import { LayoutComponent } from 'src/app/shared/layout/layout.component';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { CacheService } from 'src/app/shared/services/Cache/cache.service';
import { ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-history-cashback',
  templateUrl: './history-cashback.component.html',
  styleUrl: './history-cashback.component.css'
})
export class HistoryCashbackComponent implements OnInit, AfterViewInit, OnDestroy{
  private typeParam!: typeInterface;
  private userSubscription!: Subscription;
  nameCompany: string = '';
  showTopMenu: boolean = false;
  showRules: boolean = false;
  user!: Cliente;
  company!: Company;
  abilitInfo: boolean = false;
  
  // Mock history data - Replace with API call when available
  historyList: any[] = [];

  constructor(private router: Router,
    private connection: ConnectionService,
    private cacheService: CacheService,
    private apiService: ApiService,
    private notify: NotificationService,
    private layout: LayoutComponent,
    private location: Location
  ){

    this.connection.typeParam$.subscribe((newTypeParam) => {
      this.typeParam = newTypeParam
    })

    this.connection.nameCompany$.subscribe((newNameCompany) => {
      this.nameCompany = newNameCompany
    })

    this.connection.company$.subscribe((company) => { 
      if(company)
      {
        this.company = company;
        this.connection.getUser(this.company.company.id_company);
      }
    })

    this.userSubscription = this.connection.user$.subscribe((User) =>{
      if(User)
      {
        this.user = User;
      }
    })


  }

  ngOnInit(): void {
    this.getHistoryCashback();
  }

  ngAfterViewInit(): void {
    this.checkScreenSize();
  }

  ngOnDestroy(): void {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  goBack(){
    this.location.back();
  }

  @HostListener('window:resize', [])
  onWindowResize() {
    this.checkScreenSize();
  }

  //Verifica o tamanho da tela, esconde o Menu superior se necessario
  checkScreenSize(){
    if(window.innerWidth <= 846){

      this.showTopMenu = false;
    }
    else{
      this.showTopMenu = true;
    }
    this.layout.checkScreenSize();
  }

  getHistoryCashback(){
    this.apiService.historyCashback(this.user.id_customer, this.company.company.id_company).subscribe(
      (data) => {
        const history = data.response.history;

        if(history){
          this.historyList = history.map((item:any) => {
            const isEntry = item.type === 'in';

          return {
            id_order: item.id_order,
            date: item.createdAt
              ? new Date(item.createdAt).toLocaleDateString('pt-BR')
              : '',
            title: item.expired
              ? 'Cashback expirado'
              : isEntry
                ? 'Cashback recebido'
                : 'Cashback descontado',
            value: Number(item.value),
            type: isEntry ? 'entry' : 'exit',
            expirationAt: item.expirationAt,
            status: item.verified,
            expirationRemaining: item.expirationRemaining,
            expired: item.expired,
            origin: item.displayId
              ? `Pedido #${item.displayId}`
              : 'Integração'
          };

          });

          for (const element of this.historyList) {
            if(element.status == 0){
              this.abilitInfo = true;
              break;
            }
          }
        }
      },
      (error) => {
        this.notify.error(error);
      })
  }

  isExpiration2099(date: Date | string): boolean {
    const active =  new Date(date).getFullYear() === 2099;
    return active;
  }

  goToOrder(id_order: string){
    if(id_order != ''){
      this.router.navigate([this.nameCompany, 'order-details', id_order]);
    }
    else{
      this.notify.error('Nenhum pedido encontrado!');
    }
  }

  toggleRules(){
    this.showRules = !this.showRules;
  }
}
